import type { ResourceProps } from 'react-admin';
import { CanAccess } from 'react-admin';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import { type ComponentType, lazy } from 'react';
import { resources } from '@repo/c360-ra-components';

const AsyncPageList = lazy(() => import('./list'));

const protectedList = () => (
  <CanAccess resource={resources.blacklistRecords} action="list">
    <AsyncPageList />
  </CanAccess>
);

export default {
  list: protectedList as ComponentType<any>,
  icon: AdminPanelSettingsIcon as ComponentType<any>,
} as ResourceProps;
